"use client";

import { PropertyPickerCalendar, PropertyPicker as PropertyPickerPrimitive } from "@repo/ui/components/property-picker";
import { CalendarDays } from "lucide-react";
import type * as React from "react";
import type { PropsBase } from "react-day-picker";
import { useFieldContext } from "@/shared/forms/form-context";

interface PropertyPickerCalendarBaseProps {
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  icon?: React.ReactNode;
}

export interface PropertyPickerCalendarProps extends PropertyPickerCalendarBaseProps {
  /** Include the year in the trigger label, e.g. for birth dates. */
  showYear?: boolean;
  calendarProps?: Pick<PropsBase, "captionLayout" | "startMonth" | "endMonth" | "disabled" | "defaultMonth">;
}

export function PropertyPickerCalendarField({
  placeholder = "Set due date",
  disabled,
  className,
  icon,
  showYear,
  calendarProps,
}: PropertyPickerCalendarProps) {
  const field = useFieldContext<Date>();

  const displayValue = field.state.value
    ? field.state.value.toLocaleDateString(undefined, {
        ...(showYear && { year: "numeric" }),
        month: "short",
        day: "numeric",
      })
    : null;

  return (
    <PropertyPickerPrimitive<Date>
      value={field.state.value}
      onChange={(val) => {
        field.handleChange(val);
        field.handleBlur();
      }}
      disabled={disabled}
      placeholder={placeholder}
      className={className}
      icon={icon ?? <CalendarDays className="size-3.5" />}
      displayValue={displayValue}
    >
      <PropertyPickerCalendar
        {...calendarProps}
        selected={field.state.value ?? undefined}
        onSelect={(date) => {
          if (date) {
            field.handleChange(date);
            field.handleBlur();
          }
        }}
        mode="single"
      />
    </PropertyPickerPrimitive>
  );
}
